import axios from "axios";
import { getCookie, removeCookie } from "../utils/cookies";

const apiClient = axios.create({
  // baseURL: "http://localhost:5000/api",
  baseURL: "https://api.routerider.xyz:3000/api",
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

apiClient.interceptors.request.use((config) => {
  const token = getCookie("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const isAuthRequest = error.config?.url?.startsWith("/auth/login");

    // A 401 from /auth/login just means "wrong password" — let the login
    // page's own toast handle that instead of hard-redirecting away from it.
    if (error.response?.status === 401 && !isAuthRequest) {
      let user = null;
      try {
        user = JSON.parse(getCookie("user"));
      } catch {
        user = null;
      }

      removeCookie("token");
      removeCookie("user");
      window.location.href =
        user?.role === "owner" ? "/login_fleetowner" : "/login_customer";
    }
    return Promise.reject(error);
  },
);

export default apiClient;
